
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/cultura",
      function () {
        return require("private-next-pages/3cat/cultura/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/cultura"])
      });
    }
  